import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardMeta, Header } from "semantic-ui-react";

export const RelevantProjects = ({ profile }) => {
    const list = (() => {
        try {
            const raw = profile?.relevant_projects;
            return raw ? JSON.parse(raw) : [];
        } catch {
            return [];
        }
    })();

    if (!list.length > 0) {
        return <></>;
    }

    return (
        <Card fluid>
            <Card.Content>
                <Card.Header as="h2">{`Relevant Projects`}</Card.Header>
                <>
                    {list.map((itProject, index) => (
                        <Card fluid key={index}>
                            <CardContent>
                                <CardHeader>{itProject.title}</CardHeader>
                                <CardMeta>
                                    <span className="date">Funded by {itProject?.["Funding institution"]}</span>
                                </CardMeta>
                                <Header as="h5">Role</Header>
                                <CardDescription>{itProject?.["Role"]}</CardDescription>
                                <Header as="h4">Summary</Header>
                                <CardDescription>{itProject?.["Abstract"]}</CardDescription>
                            </CardContent>
                        </Card>
                    ))}
                </>
            </Card.Content>
        </Card>
    );
};
